import { toast } from "react-toastify";
import { TimeAutocomplete } from "./TimeAutocomplete";

interface Props {
  minute: string;
  setMinute: (newMinute: string) => void;
  disabled?: boolean;
}

const minuteList = Array.from({ length: 60 }, (_, index) => index.toString());

const candidateMap: { [key: string]: string } = {};
minuteList.forEach((time) => {
  candidateMap[time] = time;
});

export const SearchMinute: React.FC<Props> = ({
  minute,
  setMinute,
  disabled,
}) => {
  const handleChangeTextField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.value !== "") {
      const newTime = Number(event.target.value);
      if (isNaN(newTime)) {
        toast.error("숫자만 입력 가능합니다.");
        setMinute("");
        return;
      } else if (newTime < 0 || newTime > 59) {
        toast.error("0 ~ 59 사이의 숫자만 입력 가능합니다.");
        setMinute("");
        return;
      }
    }

    setMinute(event.target.value);
  };

  return (
    <TimeAutocomplete
      width="84px"
      placeholder="00"
      value={minute}
      candidateMap={candidateMap}
      onClickSelectItem={(key: string) => setMinute(key)}
      onChangeTextField={handleChangeTextField}
      isActive={minute !== ""}
      disabled={disabled}
    />
  );
};
